<template lang="pug">
button.request-button(v-if="type === 'Button'" @click="openSongRequestModal()")
	.row-img
		SingaIcon(size="large" icon="chatbubble")
	.texts
		p.request-title {{ t('modal.requestCta.rowTitle') }}
		p.subtitle {{ t('modal.requestCta') }}
button.request-plain-text(v-else @click="openSongRequestModal()")
	p {{ t('modal.requestCta') }}
</template>

<script setup lang="ts">
const { t } = useI18n()
const { $oruga } = useNuxtApp()

const SongRequest = resolveComponent('ModalsSongRequest')

const props = defineProps({
	artistName: {
		type: String,
		default: ''
	},
	type: {
		type: String,
		default: 'Button'
	}
})

const openSongRequestModal = () => {
	$oruga.modal.open({
		component: SongRequest,
		width: 768,
		props: {
			artistNamePlaceholder: props.artistName || ''
		}
	})
}
</script>

<style scoped lang="sass">
.request-button
	width: 100%
	border: none
	background: none
	padding: $spacing-16
	display: flex
	align-items: center
	cursor: pointer
	text-align: left
	&:hover
		background-color: $transparent-white-8
		border-radius: $radius-default
	&:focus
		outline: none

.row-img
	background-color: $transparent-white-4
	border-radius: $radius-default
	width: 48px
	height: 48px
	aspect-ratio: 1/1
	display: flex
	align-items: center
	justify-content: center
	.icon
		color: $color-grey-30
		width: 20px
		height: 20px

.texts
	margin-left: $spacing-16
	flex: 1
	overflow: hidden
	.request-title
		@include font(basier, medium)
		@include fontSize(s)
		color: $color-grey-30
		white-space: nowrap
		overflow: hidden
		text-overflow: ellipsis
	.subtitle
		@include font(basier, regular)
		@include fontSize(s)
		color: $color-grey-60
		white-space: nowrap
		overflow: hidden
		text-overflow: ellipsis

.request-plain-text
	display: inline-block
	border: none
	background: none
	text-align: left
	cursor: pointer
	@include font(basier, medium)
	@include fontSize(s)
	color: $color-grey-50
	text-decoration: underline
	padding: 0
	&:hover
		color: $color-grey-60
	&:focus
		outline: none
</style>
